import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { siteLogo as logo } from "../../../const";
import { login, privacyPolicy, termAndCondition, users, verifyOtp } from "../../../const";
import { sendOtp, userSignUp } from "../../../reducers/commonReducer";

const schema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
});

const UserRegister = () => {
  let width = window.innerWidth;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem("x-auth-token") && localStorage.getItem("slug") === "admin"){
      navigate(`/branchs`)
    }else if (localStorage.getItem("x-auth-token") && ((localStorage.getItem("slug") === "customer") || (localStorage.getItem("slug") === "team_leader"))){
      navigate(`/chat-users`)
    }else if (localStorage.getItem("x-auth-token") && (localStorage.getItem("slug") === "branch_leader")){
      navigate(users)
    }else(
      navigate(`/`)
    )
  }, []);

  return (
    <> 
      {/* <CommonHeader /> */}
      <div className="container-fluid">
        <div className="p-5 mbl-pedding-10">
          <Row>
            <Col md={12} className="text-center">
              <img
                className={`${width > 468 ? `w-10` : `w-50`}`}
                style={{ objectFit: "contain" }}
                src={logo}
                alt={process.env.REACT_APP_SITE_NAME}
              />
            </Col>
          </Row>
          <Row className="justify-content-between mb-40">
            <Col md={12} className="text-center">
              <h1>Signup to start Chating!!!</h1>
              <p>
                Add your phone number. we'll send you a Verification code to
                know you're real
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                validationSchema={schema}
                onSubmit={async (values) => {
                  const apiResp = await dispatch(sendOtp(values));
                  if (apiResp?.payload?.status) {
                    localStorage.setItem("phone", values.phone);
                    navigate(verifyOtp);
                  }
                }}
                initialValues={{
                  phone: "",
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3 mt-4">
                      <Col md={12} sm={12}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter Your Mobile Number"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={
                              errors.phone && touched.phone && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Button
                          variant="primary"
                          className="w-100"
                          type="submit"
                        >
                          Send OTP
                        </Button>
                        {process.env.REACT_APP_MOBILE_APK_URL && (
                          <div className="text-center mt-3">
                            <a
                              href={process.env.REACT_APP_MOBILE_APK_URL}
                              download
                              className="d-inline-flex align-items-center gap-2 text-decoration-none px-4 py-2 rounded"
                              style={{ background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7", fontWeight: 600 }}
                            >
                              <i className="bi bi-android2" style={{ fontSize: 20 }}></i>
                              Download Android App
                            </a>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <p className="f-12 text-center">
                If you are a {process.env.REACT_APP_SITE_NAME} team member, please{" "}
                <Link className="theme-link" to={login}>Login.</Link>
              </p>
            </Col>
          </Row>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default UserRegister;
